import { render, staticRenderFns } from "./addTrainDialog.vue?vue&type=template&id=81e80610&scoped=true&"
import script from "./addTrainDialog.vue?vue&type=script&lang=js&"
export * from "./addTrainDialog.vue?vue&type=script&lang=js&"
import style0 from "./addTrainDialog.vue?vue&type=style&index=0&id=81e80610&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81e80610",
  null
  
)

export default component.exports